module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-sun-fill-651e2ab7.svg";